import {
  createShippoConfiguration as publicCreateShippoConfiguration,
  getShippoConfiguration as publicGetShippoConfiguration,
  updateShippoConfiguration as publicUpdateShippoConfiguration,
  deleteShippoConfiguration as publicDeleteShippoConfiguration,
  queryShippoConfigurations as publicQueryShippoConfigurations,
  typedQueryShippoConfigurations as publicTypedQueryShippoConfigurations,
  updateExtendedFields as publicUpdateExtendedFields,
  addDeliveryRegion as publicAddDeliveryRegion,
  removeDeliveryRegion as publicRemoveDeliveryRegion,
} from './ecom-v1-shippo-configuration-shippo-configurations.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  ShippoConfigurationQuery,
  ShippoConfigurationsQueryBuilder,
  typedQueryShippoConfigurations as universalTypedQueryShippoConfigurations,
} from './ecom-v1-shippo-configuration-shippo-configurations.universal.js';
import { onShippoConfigurationCreated as publicOnShippoConfigurationCreated } from './ecom-v1-shippo-configuration-shippo-configurations.public.js';
import { onShippoConfigurationDeleted as publicOnShippoConfigurationDeleted } from './ecom-v1-shippo-configuration-shippo-configurations.public.js';
import { onShippoConfigurationUpdated as publicOnShippoConfigurationUpdated } from './ecom-v1-shippo-configuration-shippo-configurations.public.js';

function customQueryShippoConfigurations(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryShippoConfigurations(httpClient)(),
    typedQueryFunction: (query: ShippoConfigurationQuery) =>
      publicTypedQueryShippoConfigurations(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): ShippoConfigurationsQueryBuilder;
  function overloadedQuery(
    query: ShippoConfigurationQuery
  ): ReturnType<typeof universalTypedQueryShippoConfigurations>;
  function overloadedQuery(query?: ShippoConfigurationQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createShippoConfiguration: MaybeContext<
  BuildRESTFunction<typeof publicCreateShippoConfiguration> &
    typeof publicCreateShippoConfiguration
> = /*#__PURE__*/ createRESTModule(publicCreateShippoConfiguration);
export const getShippoConfiguration: MaybeContext<
  BuildRESTFunction<typeof publicGetShippoConfiguration> &
    typeof publicGetShippoConfiguration
> = /*#__PURE__*/ createRESTModule(publicGetShippoConfiguration);
export const updateShippoConfiguration: MaybeContext<
  BuildRESTFunction<typeof publicUpdateShippoConfiguration> &
    typeof publicUpdateShippoConfiguration
> = /*#__PURE__*/ createRESTModule(publicUpdateShippoConfiguration);
export const deleteShippoConfiguration: MaybeContext<
  BuildRESTFunction<typeof publicDeleteShippoConfiguration> &
    typeof publicDeleteShippoConfiguration
> = /*#__PURE__*/ createRESTModule(publicDeleteShippoConfiguration);
export const updateExtendedFields: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExtendedFields> &
    typeof publicUpdateExtendedFields
> = /*#__PURE__*/ createRESTModule(publicUpdateExtendedFields);
export const addDeliveryRegion: MaybeContext<
  BuildRESTFunction<typeof publicAddDeliveryRegion> &
    typeof publicAddDeliveryRegion
> = /*#__PURE__*/ createRESTModule(publicAddDeliveryRegion);
export const removeDeliveryRegion: MaybeContext<
  BuildRESTFunction<typeof publicRemoveDeliveryRegion> &
    typeof publicRemoveDeliveryRegion
> = /*#__PURE__*/ createRESTModule(publicRemoveDeliveryRegion);
export const queryShippoConfigurations: MaybeContext<
  BuildRESTFunction<typeof customQueryShippoConfigurations> &
    typeof customQueryShippoConfigurations
> = /*#__PURE__*/ createRESTModule(customQueryShippoConfigurations);
/**
 * Triggered when a shipping option is created.
 */
export const onShippoConfigurationCreated: BuildEventDefinition<
  typeof publicOnShippoConfigurationCreated
> &
  typeof publicOnShippoConfigurationCreated = createEventModule(
  publicOnShippoConfigurationCreated
);
/**
 * Triggered when a shipping option is deleted.
 */
export const onShippoConfigurationDeleted: BuildEventDefinition<
  typeof publicOnShippoConfigurationDeleted
> &
  typeof publicOnShippoConfigurationDeleted = createEventModule(
  publicOnShippoConfigurationDeleted
);
/**
 * Triggered when a shipping option is updated.
 */
export const onShippoConfigurationUpdated: BuildEventDefinition<
  typeof publicOnShippoConfigurationUpdated
> &
  typeof publicOnShippoConfigurationUpdated = createEventModule(
  publicOnShippoConfigurationUpdated
);

export {
  DomesticService,
  CalculationType,
  InternationalService,
  PackageType,
  SortOrder,
  WebhookIdentityType,
} from './ecom-v1-shippo-configuration-shippo-configurations.universal.js';
export {
  ShippoConfiguration,
  DomesticServiceSettings,
  ServiceSettings,
  HandlingFee,
  InternationalServiceSettings,
  PackageDetails,
  PackageDimensions,
  Address,
  StreetAddress,
  AddressLocation,
  ExtendedFields,
  CreateShippoConfigurationRequest,
  CreateShippoConfigurationResponse,
  GetShippoConfigurationRequest,
  GetShippoConfigurationResponse,
  UpdateShippoConfigurationRequest,
  UpdateShippoConfigurationResponse,
  DeleteShippoConfigurationRequest,
  DeleteShippoConfigurationResponse,
  QueryShippoConfigurationsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryShippoConfigurationsResponse,
  CursorPagingMetadata,
  Cursors,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  AddDeliveryRegionRequest,
  AddDeliveryRegionResponse,
  RemoveDeliveryRegionRequest,
  RemoveDeliveryRegionResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ShippoConfigurationCreatedEnvelope,
  ShippoConfigurationDeletedEnvelope,
  ShippoConfigurationUpdatedEnvelope,
  CreateShippoConfigurationOptions,
  UpdateShippoConfiguration,
  ShippoConfigurationsQueryResult,
  ShippoConfigurationsQueryBuilder,
  ShippoConfigurationQuerySpec,
  UpdateExtendedFieldsOptions,
  AddDeliveryRegionOptions,
  RemoveDeliveryRegionIdentifiers,
  RemoveDeliveryRegionOptions,
} from './ecom-v1-shippo-configuration-shippo-configurations.universal.js';
export { utils } from './ecom-v1-shippo-configuration-shippo-configurations.universal.js';
export {
  DomesticServiceWithLiterals,
  CalculationTypeWithLiterals,
  InternationalServiceWithLiterals,
  PackageTypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  ShippoConfigurationQuery,
} from './ecom-v1-shippo-configuration-shippo-configurations.universal.js';
